export default "__VITE_ASSET__CWzbewL1__"